import {DeletePlaylistSchema} from "@repo/shared";

import {functionHookFactory} from "../factories/functionHookFactory";

export const useDeletePlaylist = functionHookFactory(
  "deletePlaylist",
  DeletePlaylistSchema,
);
